// import { CustomerModel } from '@models/Customer';
// import { RealEstateAgentModel } from '@models/RealEstateAgent';
// import { RealEstateAssistantModel } from '@models/RealEstateAssistant';
// import { RealEstateOfficeModel } from '@models/RealEstateOffice';
import FormNames from '@constants/FormNames.enum';
import * as moment from 'moment';
import { blankPurchaseRequestHvacVM, blankPurchaseRequestPartsVM } from '@models/PurchaseRequest';
import { AddressViewModel } from '@models/common.models';
// import { initialEditEmailList } from '@models/Contract';

// const customer = new CustomerModel();
// const reAgent = new RealEstateAgentModel(); <------- These break the forms.
// const reAssistant = new RealEstateAssistantModel();
// const reOffice = new RealEstateOfficeModel();

const forms: any = {
  [FormNames.LoginForm]: {},
  [FormNames.CustomerForm]: { addresses: [] as Array<AddressViewModel> },
  [FormNames.EscrowOfficeForm]: { group: { id: 0 }, status: { id: 1 } },
  [FormNames.EscrowOfficerForm]: {
    officerType: { id: 1 },
    officerStatus: { id: 1 },
    onlineOrders: true,
    email: true
  },
  [FormNames.ProfileForm]: {},
  [FormNames.PropertyManagerForm]: {
    propMgrType: { id: 0 },
    propMgrStatus: { id: 1 },
    onlineOrders: true,
    email: true
  },
  [FormNames.PropertyManagementOfficeForm]: {
    officeStatus: { id: -1 }
  },
  [FormNames.RealEstateAgentForm]: {
    agentType: { id: 0 },
    agentRating: { id: 0 },
    agentStatus: { id: 1 },
    onlineOrders: true,
    email: true
  },
  [FormNames.RealEstateAssistantForm]: {},
  [FormNames.RealEstateOfficeForm]: {
    officeGroup: { id: 0 },
    officeStatus: { id: 1 }
  },
  [FormNames.TransactionCoordinatorForm]: {
    onlineOrders: true,
    email: true,
    transCoordType: { id: 1 },
    transCoordStatus: { id: 1 }
  },
  [FormNames.UserForm]: {},
  [FormNames.PropertyInfoForm]: { propertyAddress: { state: {} } },
  [FormNames.AffiliatesInfoForm]: {},
  [FormNames.CoverageForm]: {},
  [FormNames.PriceAdjustmentForm]: {},
  [FormNames.CustomerInfoForm]: {},
  [FormNames.EscrowInfoForm]: {},
  [FormNames.CommentForm]: {},
  [FormNames.FileUploadForm]: { fileVMs: [] },
  [FormNames.ContractResaleEmailForm]: { resaleNotifications: [] },
  [FormNames.CancelContractForm]: { cancellationDate: moment() },
  [FormNames.ServiceWorkOrderForm]: {},
  [FormNames.AuthorizationDetailForm]: {},
  [FormNames.NoRenewForm]: {},
  [FormNames.VendorGeneralInfo]: {},
  [FormNames.VendorCoverageNLimits]: {
    statReport: true,
    vendorPortal: true,
    onlineAutho: true,
    reportCard: true
  },
  [FormNames.VendorAddressNFinances]: {},
  [FormNames.VendorDefaultRatings]: {},
  [FormNames.VendorTradeMaintenance]: {},
  [FormNames.InvoiceLineCreate]: {},
  [FormNames.PurchaseApplianceInfoForm]: {},
  [FormNames.PurchaseHvacForm]: { hvacParts: [] },
  [FormNames.PurchaseHvacItemForm]: blankPurchaseRequestHvacVM,
  [FormNames.PurchasePartsForm]: { parts: [] },
  [FormNames.PurchasePartsItemForm]: blankPurchaseRequestPartsVM,
  [FormNames.HiddenPayeezyTestForm]: {},
  [FormNames.ContractEmailForm]: { contractEmailList: [] },
  [FormNames.BrandCertificationForm]: { order: 1 }
};

export default forms;



// WEBPACK FOOTER //
// ./src/_constants/Forms.ts